import { isEditorActive, RichText } from '@sitecore-jss/sitecore-jss-react';
import React from 'react';
import PropTypes from 'prop-types';
import { resolve } from '../../object/pathResolver';
import { connect } from 'react-redux';
import formatBigNumber from '../Numbers';
import isSitecoreTruthy from '../../isSitecoreTruthy/isSitecoreTruthy';

const pattern = new RegExp(/(?<={)([a-zA-Z0-9\.][^}]+)/g);

const ReplaceableRichText = props => {
  const { field, state, obj, isCurrency } = props;
  if (isEditorActive() || !field?.value || !field.value.includes('{')) {
    return <RichText {...props} />;
  }
  const tokens = field.value.match(pattern);
  tokens.forEach(token => {
    const value = resolve(token, obj || state);
    if (value !== undefined && value !== null) {
      let formattedValue = value;
      if (isSitecoreTruthy(isCurrency)) {
        formattedValue = formatBigNumber(formattedValue);
      }
      field.value = field.value.replace(`{${token}}`, formattedValue);
    }
  });
  return <RichText {...props} />;
};

const mapStateToProps = (state, props) => ({
  ...props,
  state,
});

ReplaceableRichText.propTypes = {
  field: PropTypes.shape({
    value: PropTypes.string,
  }),
  state: PropTypes.object,
  obj: PropTypes.object,
  isCurrency: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
};

export default connect(mapStateToProps)(ReplaceableRichText);
